/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * StatementsApi - axios parameter creator
 * @export
 */
export const StatementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter statements by the beneficiary client id.
         * @param {string} [beneficiarySerialTitleId] Filter statements by serial header title id (serial-level grouping).
         * @param {string} [beneficiaryTitleId] Filter statements by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to statements for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [invoiceId] Filter statements by the parent invoice id.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerWorkspaceId] Restrict the search to statements for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [searchTerm] Broad search term matched against statement number, beneficiary title name, and beneficiary client name using OR logic across those fields. When other filters are also provided (including dedicated &#x60;statementNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace a &#x60;statementNo&#x60; filter.
         * @param {string} [serviceId] Filter statements by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter statements whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {string} [statementNo] Case-insensitive substring match against the statement number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {StatementStatusEnum} [status] Filter by statement status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindAll: (beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/statement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (beneficiaryClientId !== undefined) {
                localVarQueryParameter['beneficiaryClientId'] = beneficiaryClientId;
            }
            if (beneficiarySerialTitleId !== undefined) {
                localVarQueryParameter['beneficiarySerialTitleId'] =
                    beneficiarySerialTitleId;
            }
            if (beneficiaryTitleId !== undefined) {
                localVarQueryParameter['beneficiaryTitleId'] = beneficiaryTitleId;
            }
            if (beneficiaryWorkspaceId !== undefined) {
                localVarQueryParameter['beneficiaryWorkspaceId'] =
                    beneficiaryWorkspaceId;
            }
            if (invoiceId !== undefined) {
                localVarQueryParameter['invoiceId'] = invoiceId;
            }
            if (invoiceType !== undefined) {
                localVarQueryParameter['invoiceType'] = invoiceType;
            }
            if (ownerWorkspaceId !== undefined) {
                localVarQueryParameter['ownerWorkspaceId'] = ownerWorkspaceId;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }
            if (serviceType) {
                localVarQueryParameter['serviceType'] = serviceType;
            }
            if (statementNo !== undefined) {
                localVarQueryParameter['statementNo'] = statementNo;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementControllerFindOne', 'id', id);
            const localVarPath = `/statement/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StatementFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOneDownload: (fileName, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('statementControllerFindOneDownload', 'fileName', fileName);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementControllerFindOneDownload', 'id', id);
            const localVarPath = `/statement/{id}/{fileName}`
                .replace(`{${'fileName'}}`, encodeURIComponent(String(fileName)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StatementsApi - functional programming interface
 * @export
 */
export const StatementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = StatementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter statements by the beneficiary client id.
         * @param {string} [beneficiarySerialTitleId] Filter statements by serial header title id (serial-level grouping).
         * @param {string} [beneficiaryTitleId] Filter statements by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to statements for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [invoiceId] Filter statements by the parent invoice id.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerWorkspaceId] Restrict the search to statements for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [searchTerm] Broad search term matched against statement number, beneficiary title name, and beneficiary client name using OR logic across those fields. When other filters are also provided (including dedicated &#x60;statementNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace a &#x60;statementNo&#x60; filter.
         * @param {string} [serviceId] Filter statements by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter statements whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {string} [statementNo] Case-insensitive substring match against the statement number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {StatementStatusEnum} [status] Filter by statement status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.statementControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {StatementFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOneDownload(fileName, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.statementControllerFindOneDownload(fileName, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StatementsApi - factory interface
 * @export
 */
export const StatementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StatementsApiFp(configuration);
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter statements by the beneficiary client id.
         * @param {string} [beneficiarySerialTitleId] Filter statements by serial header title id (serial-level grouping).
         * @param {string} [beneficiaryTitleId] Filter statements by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to statements for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [invoiceId] Filter statements by the parent invoice id.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerWorkspaceId] Restrict the search to statements for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {string} [searchTerm] Broad search term matched against statement number, beneficiary title name, and beneficiary client name using OR logic across those fields. When other filters are also provided (including dedicated &#x60;statementNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace a &#x60;statementNo&#x60; filter.
         * @param {string} [serviceId] Filter statements by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter statements whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {string} [statementNo] Case-insensitive substring match against the statement number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {StatementStatusEnum} [status] Filter by statement status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options) {
            return localVarFp
                .statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOne(id, options) {
            return localVarFp
                .statementControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StatementFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindOneDownload(fileName, id, options) {
            return localVarFp
                .statementControllerFindOneDownload(fileName, id, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * StatementsApi - object-oriented interface
 * @export
 * @class StatementsApi
 * @extends {BaseAPI}
 */
export class StatementsApi extends BaseAPI {
    /**
     *
     * @param {string} [beneficiaryClientId] Filter statements by the beneficiary client id.
     * @param {string} [beneficiarySerialTitleId] Filter statements by serial header title id (serial-level grouping).
     * @param {string} [beneficiaryTitleId] Filter statements by the beneficiary title id.
     * @param {string} [beneficiaryWorkspaceId] Restrict the search to statements for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
     * @param {string} [invoiceId] Filter statements by the parent invoice id.
     * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
     * @param {string} [ownerWorkspaceId] Restrict the search to statements for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
     * @param {string} [searchTerm] Broad search term matched against statement number, beneficiary title name, and beneficiary client name using OR logic across those fields. When other filters are also provided (including dedicated &#x60;statementNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace a &#x60;statementNo&#x60; filter.
     * @param {string} [serviceId] Filter statements by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required for external users.
     * @param {Array<ServiceTypeEnum>} [serviceType] Filter statements whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
     * @param {string} [statementNo] Case-insensitive substring match against the statement number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
     * @param {StatementStatusEnum} [status] Filter by statement status.
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementsApi
     */
    statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options) {
        return StatementsApiFp(this.configuration)
            .statementControllerFindAll(beneficiaryClientId, beneficiarySerialTitleId, beneficiaryTitleId, beneficiaryWorkspaceId, invoiceId, invoiceType, ownerWorkspaceId, searchTerm, serviceId, serviceType, statementNo, status, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementsApi
     */
    statementControllerFindOne(id, options) {
        return StatementsApiFp(this.configuration)
            .statementControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StatementFileNameEnum} fileName
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementsApi
     */
    statementControllerFindOneDownload(fileName, id, options) {
        return StatementsApiFp(this.configuration)
            .statementControllerFindOneDownload(fileName, id, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
